import isEmpty from "lodash-es/isEmpty";

import { extractSvgPath } from "utils/extractSvgPath";

import { DARK, LIGHT } from "constants/appModes";

export const themeSchemaGenerator = async (
  data,
  accountId,
  gradientOrders,
  hadPng,
) => {
  const composeColorScheme = (mode) => ({
    name: data[mode].name,
    brightness: mode,
    colors: {
      primary: data[mode].primary,
      gradient: gradientOrders[mode].map((index) => data[mode].gradient[index]),
    },
  });

  const appendWithPngLogo = (themes, mode) => {
    const theme = themes.find((item) => item.brightness === mode);
    theme.logo_filename = data[mode].pngLogo?.name ?? "";
    if (!data[mode].pngLogo) return;

    files.push(data[mode].pngLogo);
  };

  const files = [];

  const customization = {
    name: data.name,
    body: {
      scheme_version: 1,
      apptype: "",
      android: "market://details?id=com.visonic.neo",
      ios: "itms-apps://itunes.apple.com/app/connectalarm/id1300525077",
      customization: {
        logo: "",
        themes: [composeColorScheme(LIGHT), composeColorScheme(DARK)],
      },
    },
  };

  if (data.svgLogo) {
    customization.body.customization.logo = await extractSvgPath(data.svgLogo);
  } else if (
    data[LIGHT].pngLogo ||
    data[DARK].pngLogo ||
    hadPng?.[LIGHT] ||
    hadPng?.[DARK]
  ) {
    delete customization.body.customization.logo;
    customization.body.scheme_version = 2;
    const themes = customization.body.customization.themes;
    await appendWithPngLogo(themes, LIGHT);
    await appendWithPngLogo(themes, DARK);
  }

  return {
    id_ipmp: accountId,
    theme: customization,
    files: isEmpty(files) ? null : files,
  };
};
